import React from 'react';
import PropTypes from 'prop-types';
import { BetContainer, ImageContainer, BetPoint, BetPointWrapper } from './styles';
import Label from '../shared/Label';

const Bet365 = 'https://images2.gazzettaobjects.it/assets-mc/bet/bet365.png';
const Sportpesa = 'https://images2.gazzettaobjects.it/assets-mc/bet/sportpesa.png';
const Lottomatica = 'https://images2.gazzettaobjects.it/assets-mc/bet/lottomatica.png';
const Planetwin = 'https://images2.gazzettaobjects.it/assets-mc/bet/planetwin.png';
const Unibet = 'https://images2.gazzettaobjects.it/assets-mc/bet/unibet.png';

const customUrl = (betType, isMobile, competitionId) => {
  let url = '';
  if (betType === '1') {
    url = 'https://www.sportpesa.it/';
  }
  if (betType === '2') {
    if (isMobile) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4762730798&iu=/35821442/Gazzetta.it';
    } else {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4762694339&iu=/35821442/Gazzetta.it';
    }
  }
  if (betType === '3') {
    if (competitionId === 21) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4777729131&iu=/35821442/Gazzetta.it'; // Serie A
    } else if (competitionId === 105) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4778094665&iu=/35821442/Gazzetta.it'; // Serie B
    } else if (competitionId === 5) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4777326868&iu=/35821442/Gazzetta.it'; // Champions League
    } else if (competitionId === 6) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4777328830&iu=/35821442/Gazzetta.it'; //Europa League
    } else if (competitionId === 8) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4777732074&iu=/35821442/Gazzetta.it'; // Premier League
    } else if (competitionId === 22) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4777734684&iu=/35821442/Gazzetta.it'; // Bundesliga
    } else if (competitionId === 24) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4777730130&iu=/35821442/Gazzetta.it'; // Ligue 1
    } else if (competitionId === 23) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4777736622&iu=/35821442/Gazzetta.it'; // Liga
    } else {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4777729131&iu=/35821442/Gazzetta.it'; // DEFAULT
    }
  }
  if (betType === '4') {
    url = 'http://www.bet365.it/dl/~offer?affiliate=365_806859';
  }
  if (betType === '5') {
    if (competitionId === 21) {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4822456970&iu=/35821442/Gazzetta.it'; // Serie A
    } else {
      url = 'http://pubads.g.doubleclick.net/gampad/clk?id=4863403142&iu=/35821442/Gazzetta.it'; //Default Serie B
    }
  }
  return url;
};

const BetBar = ({
  isMobile,
  betType,
  betData,
  competitionId,
}) => (
  <BetContainer>
    {betData && betData[0] && betData[0].feed && betData[0].feed[0] &&
    <React.Fragment>
      <ImageContainer>
        {betType === '1' &&
          <img src={Sportpesa} alt="bet" />
        }
        {betType === '2' &&
          <React.Fragment>
            <img src={Planetwin} alt="bet" />
            {isMobile ?
              <img className="impressions" alt="impressions" src={`https://ad1.adfarm1.adition.com/banner?sid=4288998&kid=2722934&bid=8725768&wpt=C&ts=${Date.now()}`} />
          :
              <img className="impressions" alt="impressions" src={`https://ad1.adfarm1.adition.com/banner?sid=4288997&kid=2722934&bid=8725835&wpt=C&ts=${Date.now()}`} />
          }
          </React.Fragment>
        }
        {betType === '3' &&
          <img src={Lottomatica} alt="bet" />
        }
        {betType === '4' &&
          <img src={Bet365} alt="bet356" />
        }
        {betType === '5' &&
        <React.Fragment>
          <img src={Unibet} alt="unibet" style={{ marginTop: isMobile ? '1px' : '0px' }} />
          {competitionId === '21' ?
            <img
              src={`http://track.adform.net/adfserve/?bn=26168572;1x1inv=1;srctype=3;ord=${Date.now()}`}
              border="0"
              width="1"
              height="1"
              alt="impressions"
              style={{ opacity: 0 }}
            /> :
            <img
              src={`http://track.adform.net/adfserve/?bn=26412718;1x1inv=1;srctype=3;ord=${Date.now()}`}
              border="0"
              width="1"
              height="1"
              alt="impressions"
              style={{ opacity: 0 }}
            />
          }
        </React.Fragment>
        }
      </ImageContainer>
      <Label
        label={isMobile ? 'Scommetti:' : 'Scommetti sull\'esito della partita*:'}
        //label="Scommetti"
        size={0.75}
        color="betLabel"
        weight="bold"
      />
      <BetPointWrapper>
        <BetPoint
          isTitleNarrowMedium
          margin="0px 2px 0px 10px"
          radius="2px 0px 0px 2px"
          href={betData[0].feed[0].eventsOutcome[0].link ? betData[0].feed[0].eventsOutcome[0].link : customUrl(betType, isMobile, competitionId)}
          target="_blank"
        >
          {betData[0].feed[0].eventsOutcome[0].name}
        </BetPoint>
        <BetPoint
          radius="0px 2px 2px 0px"
          href={betData[0].feed[0].eventsOutcome[0].link ? betData[0].feed[0].eventsOutcome[0].link : customUrl(betType, isMobile, competitionId)}
          target="_blank"
        >
          {betData[0].feed[0].eventsOutcome[0].odds}
        </BetPoint>
        <BetPoint
          isTitleNarrowMedium
          margin="0px 2px 0px 6px"
          radius="2px 0px 0px 2px"
          href={betData[0].feed[0].eventsOutcome[1].link ? betData[0].feed[0].eventsOutcome[1].link : customUrl(betType, isMobile, competitionId)}
          target="_blank"
        >
          {betData[0].feed[0].eventsOutcome[1].name}
        </BetPoint>
        <BetPoint
          radius="0px 2px 2px 0px"
          href={betData[0].feed[0].eventsOutcome[1].link ? betData[0].feed[0].eventsOutcome[1].link : customUrl(betType, isMobile, competitionId)}
          target="_blank"
        >
          {betData[0].feed[0].eventsOutcome[1].odds}
        </BetPoint>
        <BetPoint
          isTitleNarrowMedium
          margin="0px 2px 0px 6px"
          radius="2px 0px 0px 2px"
          href={betData[0].feed[0].eventsOutcome[2].link ? betData[0].feed[0].eventsOutcome[2].link : customUrl(betType, isMobile, competitionId)}
          target="_blank"
        >
          {betData[0].feed[0].eventsOutcome[2].name}
        </BetPoint>
        <BetPoint
          radius="0px 2px 2px 0px"
          href={betData[0].feed[0].eventsOutcome[2].link ? betData[0].feed[0].eventsOutcome[2].link : customUrl(betType, isMobile, competitionId)}
          target="_blank"
        >
          {betData[0].feed[0].eventsOutcome[2].odds}
        </BetPoint>
      </BetPointWrapper>
      {/*<span>
        <Label
          label="Il gioco è vietato ai minori di 18 anni e può causare dipendenza patologica"
          margin={isMobile ? '0px' : '0px 0px 0px 10px'}
          color="betLabel"
        />
        <BetRibbon isTitleNarrowMedium>
          <div>18+</div>
        </BetRibbon>
      </span>*/}
    </React.Fragment>
      }
  </BetContainer>
);

BetBar.propTypes = {
  isMobile: PropTypes.bool,
  betType: PropTypes.string,
  betData: PropTypes.any,
  competitionId: PropTypes.any,
};

export default BetBar;



// WEBPACK FOOTER //
// ./src/components/BetBar/index.js